var localforage = require('localforage');
var axios = require('axios');
import Helpers from './Helpers.js';

var DisneyData = { }
DisneyData.loadedFromWeb = false;
DisneyData.loadedFromStorage = false;
DisneyData.group = 1;
DisneyData.rows = [];
//type
DisneyData.rows.push({id:1,title:"Attractions",group:1});
DisneyData.rows.push({id:2,title:"Dining",group:1});
DisneyData.rows.push({id:3,title:"Shops",group:1});
// DisneyData.rows.push({id:4,title:"Hidden Mickeys",group:1});
DisneyData.rows.push({id:5,title:"Penny Press",group:1});
DisneyData.rows.push({id:6,title:"Other Secrets",group:1});
//land
DisneyData.rows.push({id:7,title:"Main Street",group:2});
DisneyData.rows.push({id:8,title:"Tomorrowland",group:2});
DisneyData.rows.push({id:9,title:"Fantasyland",group:2});
DisneyData.rows.push({id:10,title:"Frontierland",group:2});
DisneyData.rows.push({id:11,title:"Adventureland",group:2});
DisneyData.rows.push({id:12,title:"New Orleans Square",group:2});
DisneyData.rows.push({id:13,title:"Critter Country",group:2});
DisneyData.rows.push({id:14,title:"Toontown",group:2});

//load from website and then merge in local data
DisneyData.init = function(cb) {
	cb();
	if(!DisneyData.loadedFromStorage && DisneyData.rows.length<50) {
		localforage.getItem('disney').then(function(data) {
			if(data) DisneyData.rows = data;
			cb();
		});
	}

	DisneyData.load(function() {
		if(DisneyData.loadedFromStorage) {
			cb();
			return;
		}
		localforage.getItem('disney').then(function(data) {
			DisneyData.loadedFromStorage=true;
			if(!data) {
				localforage.setItem('disney', DisneyData.rows);
				cb();
				return;
			}
			for(var i=0;i<data.length;i++) {
				var id = data[i].id;
				var found = Helpers.findArrayByID(DisneyData.rows,id);
				if(found) found.checked = data[i].checked;
			}
			localforage.setItem('disney', DisneyData.rows);
			cb();
		});

	});
}

//load from the website and replace local data
DisneyData.load = function(cb) {
	if(DisneyData.loadedFromWeb) {
		cb();
		return;
	}
	axios.get("https://www.parktopper.com/disney.php",{responseType: 'json'}).then(function(response) {
		DisneyData.loadedFromWeb = true;
		DisneyData.rows = [];
		for(var i=0;i<response.data.length;i++) {
			DisneyData.rows.push(response.data[i]);
		}
		cb();
	});		
}

DisneyData.save = function() {
	localforage.setItem('disney', DisneyData.rows);
	
	//TODO: sync to website
}

DisneyData.serialize = function() {
	var serial = [];
	for(var i=0;i<DisneyData.rows.length;i++) { //loop through all rows gathering the correct ones into array
		var row = DisneyData.rows[i];
		if(row.checked) serial.push(row.id);
	}
	return window.btoa(JSON.stringify(serial));
}

/*
AllChecked
WzEwMCwxMDEsMTAyLDEwMywxMDQsMTA1LDEwNiwxMDcsMTA4LDEwOSwxMTAsMTExLDExMiwxMTMsMTE0LDExNSwxMTYsMTE3LDExOCwxMTksMTIwLDEyMSwxMjIsMTIzLDEyNCwxMjUsMTI2LDEyNywxMjgsMTI5LDEzMCwxMzEsMTMyLDEzMywxMzQsMTM1LDEzNiwxMzcsMTM4LDEzOSwxNDAsMTQxLDE0MiwxNDMsMTQ0LDE0NSwxNDYsMTQ3LDE0OCwxNDksMTUwLDE1MSwxNTIsMTUzLDE1NCwxNTUsMTU2LDE1NywxNTgsMTU5LDE2MCwxNjEsMTYyLDE2MywxNjQsMTY1LDE2NiwxNjcsMTY4LDE2OSwxNzAsMTcxLDE3MiwxNzMsMTc0LDIzMCwyMzEsMjMyLDIzMywyMzQsMjM1LDIzNiwyMzcsMjM4LDIzOSwyNDAsMjQxLDI0MiwyNDMsMjQ0LDI0NSwyNDYsMjQ3LDI0OCwyNDksMjUwLDI1MSwyNTIsMjUzLDI1NCwyNTUsMjU2LDI1NywyNTgsMjU5LDI2MCwyNjEsMjYyLDI2MywyNjQsMjY1LDI2NiwyNjcsMjY4LDI2OSwyNzAsMjcxLDI3MiwyNzMsMjc0LDI3NSwyNzYsMjc3LDI3OCwyNzksMjgwLDI4MSwyODIsMjgzLDI4NCwyODUsMjg2LDI4NywyODgsMjg5LDI5MCwyOTEsMjkyLDI5MywyOTQsMjk1LDI5NiwyOTcsMjk4LDI5OSwzMDAsMzAxLDMwMiwzMDMsMzA0LDMwNSwzMDYsMzA3LDMwOCwzMDksMzEwLDMxMSwzMTIsMzEzLDMxNCwzMTUsMzE2LDMxNywzMTgsMzE5LDMyMCwzMjEsMzIyLDMyMywzMjQsMzI1LDMyNiwzMjcsMzI4LDMyOSwzMzAsMzMxLDMzMiwzMzMsMzM0LDMzNSwzMzYsMzM3LDMzOCwzMzksMzQwLDM0MSwzNDIsMzQzLDM0NCwzNDUsMzQ2LDM0NywzNDgsMzQ5LDM1MCwzNTEsMzUyLDM1MywzNTQsMzU1LDM1NiwzNTcsMzU4LDM1OSwzNjAsMzYxLDM2MiwzNjMsMzY0LDM2NSwzNjYsMzY3LDM2OCwzNjksMzcwLDM3MSwzNzIsMzczLDM3NCwzNzUsMzc2LDM3NywzNzgsMzc5LDM4MCwzODEsMzgyLDM4MywzODQsMzg1LDM4NiwzODcsMzg4LDM4OSwzOTAsMzkxLDM5MiwzOTMsMzk0LDM5NSwzOTYsMzk3XQ==
*/
DisneyData.restore = function(bdata) {
	try {
		var data = JSON.parse(window.atob(bdata));
	} catch(error) {
		return;
	}
	for(var i=0;i<DisneyData.rows.length;i++) { //loop through all rows gathering the correct ones into array
		var row = DisneyData.rows[i];
		row.checked = false;
		if(data.includes(row.id)) row.checked = true;
	}
	DisneyData.save();
}

DisneyData.getData = function(group,stack) {
	var rows = [];
	for(var i=0;i<DisneyData.rows.length;i++) { //loop through all rows gathering the correct ones into array
		var row = DisneyData.rows[i];

		if(stack.length===0 && row && group===row.group) { //stack is empty, so at top level
			//include rows that have the same group number as I am current viewing at top level
			row.percent = DisneyData.calcPercents(row);
			rows.push(row);
		} else if(stack.length===1 && row && row.group && group!==row.group) { //stack is one level deep so show alternate grouping
			//secondary categorie
			if(DisneyData.rows.length<50 || DisneyData.calcChildren(row,stack[0])>0) { //need to omit any empty secondary categories
				row.percent = DisneyData.calcPercents(row,stack[0]);
				rows.push(row);
			}
		} else if(stack.length===2 && group===1 && row.type===stack[0] && (row.land===stack[1] || stack[1]===0)) {
			//activity > land > row
			rows.push(row);
		} else if(stack.length===2 && group===2 && (row.type===stack[1] || stack[1]===0) && row.land===stack[0]) {
			//land > activity > row
			rows.push(row);
		} else if(stack.length===3 && stack[stack.length-1]===row.id) {
			rows.push(row);
		}
	}
	if(stack.length===1) { //If stack length is 1, the secondary category needs an "all" option
		var zero = {id:0,title:"All",group:(group===1)?2:1};
		zero.percent = DisneyData.calcPercents(zero,stack[0]);
		rows.push(zero);
	}
	if(stack.length===2) {
		rows.sort(function(a,b) {
			if(a.title<b.title) return -1;
			if(a.title>b.title) return 1;
			return 0;
		});
	}

	if(rows.length>10) {
		rows.splice(10,0,{ad:true});
	}
	if(rows.length>20) {
		//rows.splice(20,0,{ad:true});
	}

	return rows;
}

DisneyData.changeGroup = function(group) {
	DisneyData.group = group;
}

DisneyData.checkedRow = function(row) {
	if(row.checked) row.checked=false;
	else row.checked=true;
	DisneyData.save();
}

DisneyData.calcPercents = function(parent,grandparent) {
	var num = 0;
	var checked = 0;
	for(var i=0;i<DisneyData.rows.length;i++) {
		var row = DisneyData.rows[i];
		if(parent.group===1 && row && row.type && (row.type===parent.id || parent.id===0)) {
			if(grandparent===undefined || grandparent===row.land) {
				num++;
				if(row.checked) checked++;
			}
		} else if(parent.group===2 && row && row.land && (row.land===parent.id || parent.id===0)) {
			if(grandparent===undefined || grandparent===row.type) {
				num++;
				if(row.checked) checked++;
			}
		}
	}
	if(num===0 || checked===0) return 0;
	return Math.floor(checked*100/num);
}

DisneyData.calcChildren = function(parent,grandparent) {
	var num = 0;
	for(var i=0;i<DisneyData.rows.length;i++) {
		var row = DisneyData.rows[i];
		if(parent.group===1 && row && row.type && (row.type===parent.id || parent.id===0)) {
			if(grandparent===undefined || grandparent===row.land) {
				num++;
			}
		} else if(parent.group===2 && row && row.land && (row.land===parent.id || parent.id===0)) {
			if(grandparent===undefined || grandparent===row.type) {
				num++;
			}
		}
	}
	return num;
}

export default DisneyData;



// WEBPACK FOOTER //
// ./src/DisneyData.js